import ModusServiceCollection from "../ModusServiceCollection";
import LaboratoryClientModel from "../../models/modus/LaboratoryClientModel";

/**
 * LaboratoryClient collection
 */
export default class LaboratoryClientCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return LaboratoryClientModel;
  }

}
